import storage from './storage';
import { SLOT_BOOKING } from '@/constants/default';
import { Occasions } from '@/types/occasion';

export const DEFAULT_CONFIG = {
  appLabel: 'HungerBox',
  no_paid_orders: false,
  loader_delay: 300,
  allowed_for_guest_ordering: [],
  project_code_message: 'Please enter valid project code.',
  subDomain: '',
  projectcode_place_holder: 'Project Code',
  review_allowed_employee_types: {},
  disable_kitchen_system_check_for_qr_activation: false,
  group_location: false,
  company_id: -1,
  banner_auto_move_time: 0,
  order_tracker_auto_move_time: 5000,
  order_tracker_refresh_time: 30000,
  pre_order_tracker_visible_time: 1800000,
  enable_pick_up_address: false,
  order_type_for_outlet_directions: ['dine in'],
  vendor_type_for_outlet_directions: ['restaurant'],
  flutter_module_enabled: true,
  firebase_performance_enabled: true,
  order_bill_vendor_address_text: 'Food Partner Outlet',
  enable_firestore: true,
  firestore_query_limit: 100,
  enable_hsn: false,
  show_entry_qr: false,
  auth_skip: false,
  enable_send_invoice: true,
  add_field_for_invoice_available: false,
  send_invoice_time_limit: 12, // in months
  invoice_additional_text_info:
    'For the additional fields to be added to the invoice, please prefer sending the invoice over mail',
  should_set_invoice_email: true,
  invoice_email_pattern: '',
  subscription_v2_enabled: false,
  exclude_invoice_vendor_types: [SLOT_BOOKING, 'event'],
  upi_regex: '[\\S]+[@][\\S]+',
  qr_validity_time: 10000,
  company_level_dynamic_qr_enabled: false,
  dynamic_qr_enabled_locations: [],
  company_level_menu_management_enabled: false,
  show_my_account: true,
  direct_cancellation: '',
  show_wallet_breakup: false,
  skip_reset: true,
  direct_soft_update: false,
  auto_update: true,
  direct_soft_update_gap: 172800000,
  workstation_address: 'Workstation Address',
  app_name: '',
  location_permission_info:
    'HungerBox needs your permission to access location in background in order to track your bluetooth and discover devices near you, the location data collected is not stored by HungerBox',
  ignore_feedback_on_skip: false,
  cur_version: 0,
  order_detail_refresh_time: 30000,
  company_paid_text: 'Company Paid',
  on_campus: 'Cafeteria Counter',
  minimum_balance_error: 'Insufficient balance. Please add one more payment option to continue',
  btn_on_banner: false,
  order_feedback_delay: 1800000,
  order_feedback_time_limit: 0, // 7 days // 0 n ios
  open_order_time_limit: 172800000,
  company_logo: 'Hungerbox cafe',
  login_methods: ['username', 'email'],
  wallet_present: true,
  consider_rules: true,
  excluded_vendors: [],
  desk_refrence_ask_msg: 'Please Enter Desk Number',
  email_verification_ask_msg: 'Please enter a valid email',
  is_analytics_enabled: true,
  show_location: true,
  signup_terms: {
    terms_and_policy_text: 'I agree to Terms & Conditions, Privacy Policy.',
    terms_start_index: 11,
    terms_end_index: 29,
    privacy_policy_start_index: 32,
    privacy_policy_end_index: 46,
  },
  hide_qrcode: false,
  hide_order_pin: false,
  show_terms_and_privacy_policy_on_signup: true,
  order_type_for_mobile_verification: [],
  sso_login_text: 'SSO Login',
  place_order: true,
  auto_logout: false,
  vendor_feedback_comment_mandatory: -1,
  vendor_feedback_comment_mandatory_msg:
    'What went wrong? Please provide us additional info to serve better.',
  country_code: '+91',
  card_login: false,
  meal_card_not_allowed_msg: '',
  is_wallet_displayed: false,
  is_location_fixed: true,
  new_juspay_recharge: true,
  stop_simple_payload: false,
  is_recharge_allowed: false,
  update_redirect_url:
    'https://play.google.com/store/apps/details?id:com.hungerbox.customer.common',
  review_comment: true,
  is_guest_order: false,
  chat_head: true,
  otp_login_allowed: true,
  picture_in_picture: false,
  minimum_recharge_amount: 200,
  guest_registration: false,
  is_sign_up_enabled: false,
  menu_review_enabled: false,
  hide_price: false,
  hide_timings: false,
  launch_date: '3-8-2016',
  email_verification: [],
  show_delivery_number: 'reached_location',
  otp_on_order: false,
  zeta_sms_keyword: '.+(otp|pin).+(hungerbox|eatgood technologies).+',
  navbars: [],
  bottombars: [],
  Juspay_payment_option: [],
  isHealthEnabled: false,
  is_sso_login: false,
  onboarding_delay: 3000,
  reccomendation_on_review: true,
  ext_wlt_rch_enabled: false,
  show_simpl: true,
  hb_wallet_compulsory: false,
  is_sso_login_only: false,
  should_take_review_on_start: true,
  email_pattern: '',
  signup_email_activation: false,
  is_feedback_skip_allowed: true,
  express_checkout: false,
  coach_mark_visible: false,
  sentiment_feedback: false,
  sentiment_feedback_count: 3,
  qrScreenShotAllowed: false,
  show_guest_order_pin: false,
  handed_over_to_text: 'Security Desk',
  otp_over_email: true,
  check_cart_end_time: true,
  ask_gender_info: false,
  project_code_array: [],
  show_gst: false,
  show_order_pending_label: false,
  show_order_delivery_time: false,
  terms_of_use: '',
  privacy_policy: '',
  left_threshold: 2,
  free_meal_exhaust_msg:
    'As per food policy, you are not allowed to add anymore free meals. Please select some other item from the menu.',
  congestion_msg:
    'To maintain cafe congestion, please book another cafe entry slot in the next occasion',
  show_preorder_occasion_time: true,
  free_menu_mapping: false,
  email_verification_message: 'Please verify your ibm email in order to enjoy complementary items',
  verify_email_message: 'Verification link has been sent to your email. Please check your inbox',
  resend_email_message:
    "Email verification is pending. Tap on Resend, if you haven't received the link yet",
  order_status_window: 'Order Status Window',
  guest_count_for_cafeteria_selection: 0,
  max_recharge: 2000,
  low_paytm_balance_msg: 'Insufficient Balance. Please select another payment method',
  postpaid_not_eligible: '',
  default_delivery_option: 1,
  show_user_settings: true,
  convenience_charge_applicable: false,
  payment_due_header: 'Clear your dues',
  auth_expiry_as_percent: 75,
  vendor_feedback_checkbox_mandatory_ratings: [],
  vendor_feedback_checkbox_mandatory_msg:
    'To help us understand better, please select atleast one of the issues listed here.',
  currency_symbol: '₹',
  disable_sms_notifications: false,
  disable_view_more_payment: false,
  show_vendor_pending_order_count: true,
  show_vendor_expected_delivery_time: true,
  enable_forgot_password: true,
  help_support_email: 'hello@hungerbox.com',
  show_occasion_time: true,
  signup_using_email_enabled: false,
  hide_forgot_password: false,
  otp_on_email_placeholder: 'Email ID',
  clear_old_pwa_cache: false,
  clear_new_pwa_cache: false,
};

export const setLocation = (locationId: number | string) => {
  try {
    const locationMap = storage.getItem('locationMap');
    if (locationMap) {
      const location = locationMap[locationId];
      if (location) {
        storage.setItem('currentLocation', location);
        sessionStorage.setItem('currentLocation', JSON.stringify(location));
        return true;
      }
      return false;
    }
    storage.setItem('currentLocation', locationMap[Object.keys(locationMap)[0]]);
    sessionStorage.setItem(
      'currentLocation',
      JSON.stringify(locationMap[Object.keys(locationMap)[0]])
    );
    return false;
  } catch (error) {}
};

export const setOccasion = (occasionId: number | string) => {
  try {
    const occasions = storage.getItem('occasions');
    if (occasions) {
      const occasion = occasions.find((occasion: Occasions) => occasion.id === Number(occasionId));
      if (occasion) {
        storage.setItem('currentOccasion', occasion);
        sessionStorage.setItem('currentOccasion', JSON.stringify(occasion));
        return true;
      }
      return false;
    }
    storage.setItem('currentOccasion', occasions[0]);
    sessionStorage.setItem('currentOccasion', JSON.stringify(occasions[0]));
    return false;
  } catch (error) {}
};
